module.exports = __webpack_public_path__ + "static/media/video.6594adfc.png";